import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { GenericNumberInput } from '../../components';
import { InputModel } from '../../models';
import { InputWithoutSource } from '../../componentTypes';


const DeductionValueInput: InputWithoutSource = ({ input }) => (
    <GenericNumberInput label={input.name} input={input} />
);

DeductionValueInput.meta = {
    inputType: InputModel.name
};

export default observer(DeductionValueInput);
